<template>
  <div class="order-edit-container">
    <el-card class="order-card">
      <div class="page-header">
        <h2>编辑订单</h2>
        <el-button @click="$router.back()">返回</el-button>
      </div>
      
      <el-form ref="orderForm" :model="orderForm" :rules="orderRules" label-width="120px" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">项目信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="orderForm.projectName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单号">
              <el-input v-model="orderForm.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择客户" prop="customerId">
              <el-select 
                v-model="orderForm.customerId" 
                filterable 
                placeholder="请选择客户" 
                style="width: 100%"
                :loading="loading.customers"
                @change="handleCustomerChange">
                <el-option
                  v-for="item in customerOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="orderForm.contact"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="orderForm.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="address">
              <el-input v-model="orderForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="样品数量" prop="sampleCount">
              <el-input-number 
                v-model="orderForm.sampleCount" 
                :min="1" 
                :max="999" 
                placeholder="请输入样品数量" 
                style="width: 100%"
                @change="updatePriceByTestCount">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预期完成时间" prop="expectedCompletionDate">
              <el-date-picker
                v-model="orderForm.expectedCompletionDate"
                type="date"
                placeholder="选择预期完成时间"
                value-format="yyyy-MM-dd"
                :picker-options="{
                  disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7; // 禁止选择今天之前的日期
                  }
                }"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="订单状态">
              <el-tag :type="getStatusType(orderForm.status)" style="width: 100%; text-align: center;">{{ orderForm.status }}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="orderForm.remark" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择商家" prop="merchantId">
              <el-select 
                v-model="orderForm.merchantId" 
                filterable 
                placeholder="请选择商家" 
                style="width: 100%"
                :loading="loading.merchants"
                @change="handleMerchantChange">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="deviceId">
              <el-select 
                v-model="orderForm.deviceId" 
                filterable 
                placeholder="请选择仪器" 
                style="width: 100%"
                :disabled="!orderForm.merchantId"
                @change="handleEquipmentChange">
                <el-option
                  v-for="item in equipmentOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div class="form-tip" v-if="!orderForm.merchantId">请先选择商家</div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="仪器型号">
              <el-input v-model="orderForm.deviceModel" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考价格">
              <el-input v-model="orderForm.referencePrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="实际价格" prop="actualPrice">
              <el-input v-model="orderForm.actualPrice">
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="merchantContact">
              <el-input v-model="orderForm.merchantContact"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="merchantPhone">
              <el-input v-model="orderForm.merchantPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="merchantAddress">
              <el-input v-model="orderForm.merchantAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">测试要求附件</span>
        </el-divider>
        
        <el-form-item>
          <el-upload
            ref="upload"
            class="upload-demo"
            drag
            action=""
            :http-request="customUpload"
            multiple
            :headers="uploadHeaders"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-error="handleError"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :limit="10"
            :show-file-list="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">
              支持上传PDF、Word、Excel或图片格式文件，每个文件不超过10MB
              <span style="color: #F56C6C; margin-left: 10px;">必须先选择客户才能上传文件</span>
            </div>
          </el-upload>
        </el-form-item>
        
        <div class="file-list-container" v-if="fileList.length > 0">
          <h3 class="file-list-title">附件列表</h3>
          <el-table
            :data="fileList"
            style="width: 100%"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
              <template slot-scope="scope">
                {{ scope.row.fileId || scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)" 
                  style="margin-left: 10px;">下载</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  style="color: #F56C6C; margin-left: 10px;"
                  @click="removeFile(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-file">
          <el-empty description="暂无附件"></el-empty>
        </div>

        <div class="form-actions">
          <el-button type="primary" @click="saveOrderEdit">保存修改</el-button>
          <el-button @click="cancelEdit">取消</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'EditOrder',
  data() {
    return {
      loading: {
        page: false,
        customers: false,
        merchants: false
      },
      originalOrderData: {
        id: '',
        customerId: '',
        merchantId: ''
      },
      orderForm: {
        projectName: '',
        customer: '',
        customerId: '',
        orderNo: '',
        contact: '',
        phone: '',
        address: '',
        sampleCount: 1,
        expectedCompletionDate: '',
        remark: '',
        merchant: '',
        merchantId: '',
        equipment: '',
        deviceId: '',
        deviceModel: '',
        merchantContact: '',
        merchantPhone: '',
        merchantAddress: '',
        referencePrice: '',
        actualPrice: '',
        status: '未邮寄',
        orderFile: []
      },
      fileList: [],
      customerOptions: [],
      merchantOptions: [],
      equipmentOptions: [],
      customerData: {},
      merchantData: {},
      uploadHeaders: {
        Authorization: localStorage.getItem('token') || ''
      },
      uploadingFiles: 0,
      pendingUploads: undefined, // 存储待批量上传的文件
      orderRules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        sampleCount: [
          { required: true, message: '请输入样品数量', trigger: 'blur' }
        ],
        expectedCompletionDate: [
          { required: true, message: '请选择预期完成时间', trigger: 'change' }
        ],
        merchantId: [
          { required: true, message: '请选择商家', trigger: 'change' }
        ],
        deviceId: [
          { required: true, message: '请选择仪器', trigger: 'change' }
        ],
        merchantContact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        merchantPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        merchantAddress: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        actualPrice: [
          { required: true, message: '请输入实际价格', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    // 监听样品数量变化，重新计算价格
    'orderForm.sampleCount': function(newVal) {
      // 只有当仪器已选择时才重新计算价格
      if (this.orderForm.deviceId) {
        this.updatePriceByTestCount();
      }
    }
  },
  created() {
    // 加载客户和商家数据
    this.fetchCustomerList()
    this.fetchMerchantList()
    
    // 获取订单详情
    const orderId = this.$route.params.id
    if (orderId) {
      this.fetchOrderDetail(orderId)
    }
  },
  methods: {
    async fetchOrderDetail(orderId) {
      this.loading.page = true
      try {
        // 调用API获取订单详情
        const res = await adminApi.getOrderById(orderId)
        if (res) {
          console.log('获取到的订单数据:', res)
          
          const orderData = res
          
          // 保存原始ID，在编辑时使用
          this.originalOrderData = {
            id: orderId,
            customerId: orderData.customerId,
            merchantId: orderData.merchantId
          }
          
          // 映射订单数据到表单
          this.orderForm = {
            projectName: orderData.projectName || '',
            customer: orderData.customerName || '',
            customerId: orderData.customerId || '',
            orderNo: orderData.orderSn || '',
            contact: orderData.customerPerson || '',
            phone: orderData.customerPhone || '',
            address: orderData.customerAddress || '',
            sampleCount: orderData.testCount || 1,
            expectedCompletionDate: orderData.expectedEndTime || '',
            remark: orderData.remarks || '',
            merchant: orderData.merchantName || '',
            merchantId: orderData.merchantId || '',
            equipment: orderData.deviceName || '',
            deviceId: orderData.deviceId || '',
            deviceModel: orderData.deviceModel || '',
            merchantContact: orderData.merchantPerson || '',
            merchantPhone: orderData.merchantPhone || '',
            merchantAddress: orderData.merchantAddress || '',
            referencePrice: orderData.guidePrice || '',
            actualPrice: orderData.actualPrice || '',
            status: this.getStatusText(orderData.orderStatus) || '未邮寄',
            orderFile: orderData.orderFile || []
          }
          
          // 预加载仪器选项
          if (this.orderForm.merchantId) {
            // 等待商家列表加载完成
            if (this.merchantData[this.orderForm.merchantId]) {
              // 已加载，直接使用
              this.equipmentOptions = this.merchantData[this.orderForm.merchantId].equipment || [];
              console.log('预加载仪器选项:', this.equipmentOptions);
              
              // 确保显示设备名称而不是ID
              if (this.orderForm.deviceId) {
                console.log('尝试查找设备ID:', this.orderForm.deviceId);
                const selectedDevice = this.equipmentOptions.find(item => item.value === this.orderForm.deviceId);
                if (selectedDevice) {
                  this.orderForm.equipment = selectedDevice.label;
                  this.orderForm.deviceModel = selectedDevice.deviceModel || orderData.deviceModel || '';
                  console.log('已选仪器信息:', selectedDevice);
                } else {
                  console.warn('未找到匹配的仪器:', this.orderForm.deviceId);
                  // 如果没找到对应的仪器选项，尝试添加一个临时选项
                  if (orderData.deviceName || orderData.deviceModel) {
                    const tempOption = {
                      value: this.orderForm.deviceId,
                      label: orderData.deviceName || `仪器(ID:${this.orderForm.deviceId})`,
                      deviceModel: orderData.deviceModel || '',
                      referencePrice: orderData.guidePrice || orderData.referencePrice || '0'
                    };
                    this.equipmentOptions.push(tempOption);
                    console.log('添加临时仪器选项:', tempOption);
                  }
                }
              }
            } else {
              // 如果商家数据尚未加载完成，等待加载
              const checkMerchantData = setInterval(() => {
                if (this.merchantData[this.orderForm.merchantId]) {
                  clearInterval(checkMerchantData);
                  this.equipmentOptions = this.merchantData[this.orderForm.merchantId].equipment || [];
                  
                  // 确保显示设备名称而不是ID
                  if (this.orderForm.deviceId) {
                    const selectedDevice = this.equipmentOptions.find(item => item.value === this.orderForm.deviceId);
                    if (selectedDevice) {
                      this.orderForm.equipment = selectedDevice.label;
                      this.orderForm.deviceModel = selectedDevice.deviceModel || orderData.deviceModel || '';
                      console.log('已选仪器信息:', selectedDevice);
                    } else {
                      console.warn('未找到匹配的仪器:', this.orderForm.deviceId);
                      // 如果没找到对应的仪器选项，尝试添加一个临时选项
                      if (orderData.deviceName || orderData.deviceModel) {
                        const tempOption = {
                          value: this.orderForm.deviceId,
                          label: orderData.deviceName || `仪器(ID:${this.orderForm.deviceId})`,
                          deviceModel: orderData.deviceModel || '',
                          referencePrice: orderData.guidePrice || orderData.referencePrice || '0'
                        };
                        this.equipmentOptions.push(tempOption);
                        console.log('添加临时仪器选项:', tempOption);
                      }
                    }
                  }
                }
              }, 500);
              
              // 设置5秒超时，避免无限等待
              setTimeout(() => {
                clearInterval(checkMerchantData);
              }, 5000);
            }
          }
          
          // 处理附件列表
          if (orderData.orderFile && Array.isArray(orderData.orderFile)) {
            console.log('原始附件数据:', orderData.orderFile)
            
            this.fileList = orderData.orderFile.map(file => {
              // 优先使用fileUrl字段，如果没有则尝试url字段
              const fileUrl = file.fileUrl || file.url || ''
              
              return {
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                uploadTime: file.uploadTime || new Date(),
                url: fileUrl,
                status: 'success'
              }
            })
          } else {
            this.fileList = []
          }
          
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading.page = false
      }
    },
    handleCustomerChange(value) {
      if (this.customerData[value]) {
        const customerInfo = this.customerData[value];
        this.orderForm.contact = customerInfo.contact;
        this.orderForm.phone = customerInfo.phone;
        this.orderForm.address = customerInfo.address;
      }
    },
    
    handleMerchantChange(value) {
      console.log('选择商家:', value);
      if (this.merchantData[value]) {
        const merchantInfo = this.merchantData[value];
        this.orderForm.merchantContact = merchantInfo.contact;
        this.orderForm.merchantPhone = merchantInfo.phone;
        this.orderForm.merchantAddress = merchantInfo.address;
        
        // 更新仪器选项
        this.equipmentOptions = merchantInfo.equipment || [];
        console.log(`已加载商家[${value}]的${this.equipmentOptions.length}个仪器选项:`, this.equipmentOptions);
        
        // 清空已选仪器及其相关数据
        this.orderForm.deviceId = ''; 
        this.orderForm.equipment = '';
        this.orderForm.deviceModel = '';
        // 清空价格
        this.orderForm.referencePrice = '';
        this.orderForm.actualPrice = '';
        
        // 如果仪器列表为空，提示用户
        if (!this.equipmentOptions || this.equipmentOptions.length === 0) {
          this.$message.warning('该商家暂无可用仪器，请联系管理员添加仪器');
        }
      } else {
        console.warn('找不到商家数据:', value);
        this.equipmentOptions = [];
        this.$message.warning('无法获取该商家的仪器列表');
      }
    },
    
    handleEquipmentChange(value) {
      // 根据选择的仪器回填价格
      console.log('选择仪器:', value);
      if (this.orderForm.merchantId && value) {
        const merchantEquipment = this.merchantData[this.orderForm.merchantId]?.equipment || [];
        const selectedEquipment = merchantEquipment.find(item => item.value === value);
        
        if (selectedEquipment) {
          console.log('找到选中的仪器:', selectedEquipment);
          // 回填参考价格和实际价格，并乘以样品数量
          const basePrice = parseFloat(selectedEquipment.referencePrice) || 0;
          const totalPrice = basePrice * this.orderForm.sampleCount;
          
          this.orderForm.referencePrice = totalPrice.toFixed(2);
          this.orderForm.actualPrice = totalPrice.toFixed(2);
          
          // 回填仪器型号和设备名称
          this.orderForm.deviceModel = selectedEquipment.deviceModel || '';
          this.orderForm.equipment = selectedEquipment.label || '';
          console.log('已更新订单表单:', {
            equipment: this.orderForm.equipment,
            deviceModel: this.orderForm.deviceModel,
            referencePrice: this.orderForm.referencePrice,
            actualPrice: this.orderForm.actualPrice
          });
        } else {
          console.warn('未找到匹配的仪器:', value);
        }
      }
    },
    
    customUpload(options) {
      const { file, onProgress, onSuccess, onError } = options;
      
      // 再次检查是否已选择客户
      if (!this.orderForm.customerId) {
        onError(new Error('请先选择客户再上传文件'));
        this.$message.error('请先选择客户再上传文件');
        return;
      }
      
      // 再次检查文件类型
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif'
      ];
      
      const isAllowedType = allowedTypes.includes(file.type);
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel或图片格式的文件');
        // 返回false明确阻止上传
        return false;
      }
      
      // 增加计数器
      this.uploadingFiles++;
      
      // 使用单文件上传API
      adminApi.uploadFile(file, this.orderForm.customerId, (percent) => {
        onProgress({ percent });
        console.log(`上传进度: ${parseInt(percent)}%`);
      }).then(response => {
        if (response && typeof response === 'object') {
          onSuccess(response);
          this.handleSuccess(response, file);
        } else {
          this.uploadingFiles--;
          onError(new Error('接口返回格式不正确'));
          this.$message.error(`文件 ${file.name} 上传失败：接口返回格式不正确`);
        }
      }).catch(error => {
        this.uploadingFiles--;
        onError(error);
        this.handleError(error, file);
      });
    },
    
    handleSuccess(response, file) {
      this.uploadingFiles--;
      console.log('上传成功，返回数据:', response);
      
      // 从返回数据中提取需要的信息
      let fileData = response;
      
      // 确保URL是完整的URL
      let fileUrl = fileData.url;
      // 如果URL不是以http开头，则拼接基础URL
      if (fileUrl && !fileUrl.startsWith('http') && !fileUrl.startsWith('blob:')) {
        fileUrl = adminApi.ApiUrl + (fileUrl.startsWith('/') ? '' : '/') + fileUrl;
      }
      
      // 创建一个新的文件对象添加到文件列表
      const newFile = {
        name: file.name,
        size: file.size,
        uploadTime: new Date(),
        status: 'success',
        url: fileUrl, 
        fileId: fileData.fileId,
        // 保存原始URL，以防后续需要
        originalUrl: fileData.url
      };
      
      // 将新文件添加到文件列表
      this.fileList.push(newFile);
      
      // 同时更新到orderForm.orderFile数组，用于表单提交
      this.orderForm.orderFile.push({
        fileId: fileData.fileId,
        fileName: fileData.fileId || file.name,
        fileUrl: fileUrl,
        filePath: fileData.path,
        fileSize: fileData.size
      });
      
      this.$message.success(`文件 ${file.name} 上传成功`);
    },
    
    handleError(err, file) {
      this.uploadingFiles--;
      console.error('文件上传失败:', err);
      this.$message.error(`文件 ${file.name} 上传失败，请重试`);
    },
    
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    
    handleRemove(file) {
      // 这个方法由el-upload调用，对应上传组件的内置删除
      console.log('移除文件:', file);
      
      // 只有在文件确实存在于fileList中才进行处理和显示成功消息
      const index = this.fileList.findIndex(item => item.name === file.name);
      if (index !== -1) {
        // 获取要删除的文件
        const removedFile = this.fileList[index];
        
        // 找到对应文件并从fileList中删除
        this.fileList.splice(index, 1);
        
        console.log('尝试删除文件(handleRemove):', removedFile);
        
        // 同时从orderForm.orderFile中移除对应文件
        let orderFileIndex = -1;
        
        // 首先尝试通过fileId匹配
        if (removedFile.fileId) {
          orderFileIndex = this.orderForm.orderFile.findIndex(item => 
            item.fileId === removedFile.fileId);
        }
        
        // 如果通过fileId没找到，尝试通过文件名和URL匹配
        if (orderFileIndex === -1) {
          orderFileIndex = this.orderForm.orderFile.findIndex(item => 
            (item.fileName === removedFile.name || item.fileName === removedFile.fileId) &&
            (item.fileUrl === removedFile.url || (item.fileUrl && removedFile.url && 
            (item.fileUrl.includes(removedFile.name) || removedFile.url.includes(item.fileName)))));
        }
        
        // 如果还没找到，使用更宽松的匹配方式
        if (orderFileIndex === -1) {
          orderFileIndex = this.orderForm.orderFile.findIndex(item => 
            (item.fileName && removedFile.name && item.fileName.includes(removedFile.name)) || 
            (item.fileName && removedFile.fileId && item.fileName.includes(removedFile.fileId)) ||
            (removedFile.name && item.fileUrl && item.fileUrl.includes(removedFile.name)));
        }
        
        if (orderFileIndex !== -1) {
          console.log('删除orderForm中的文件:', this.orderForm.orderFile[orderFileIndex]);
          this.orderForm.orderFile.splice(orderFileIndex, 1);
          this.$message.success('文件已删除');
        } else {
          console.error('未找到要删除的文件在orderForm.orderFile中的索引', removedFile);
          this.$message.warning('文件已从列表中移除，但可能未能从表单数据中删除');
        }
      }
    },
    
    removeFile(index) {
      const removedFile = this.fileList[index];
      this.fileList.splice(index, 1);
      
      console.log('尝试删除文件:', removedFile);
      
      // 同时从orderForm.orderFile中移除
      let orderFileIndex = -1;
      
      // 首先尝试通过fileId匹配
      if (removedFile.fileId) {
        orderFileIndex = this.orderForm.orderFile.findIndex(file => 
          file.fileId === removedFile.fileId);
      }
      
      // 如果通过fileId没找到，尝试通过文件名和URL匹配
      if (orderFileIndex === -1) {
        orderFileIndex = this.orderForm.orderFile.findIndex(file => 
          (file.fileName === removedFile.name || file.fileName === removedFile.fileId) &&
          (file.fileUrl === removedFile.url || (file.fileUrl && removedFile.url && 
          (file.fileUrl.includes(removedFile.name) || removedFile.url.includes(file.fileName)))));
      }
      
      // 如果还没找到，使用更宽松的匹配方式
      if (orderFileIndex === -1) {
        orderFileIndex = this.orderForm.orderFile.findIndex(file => 
          (file.fileName && removedFile.name && file.fileName.includes(removedFile.name)) || 
          (file.fileName && removedFile.fileId && file.fileName.includes(removedFile.fileId)) ||
          (removedFile.name && file.fileUrl && file.fileUrl.includes(removedFile.name)));
      }
      
      if (orderFileIndex !== -1) {
        console.log('删除orderForm中的文件:', this.orderForm.orderFile[orderFileIndex]);
        this.orderForm.orderFile.splice(orderFileIndex, 1);
        this.$message.success('文件已删除');
      } else {
        console.error('未找到要删除的文件在orderForm.orderFile中的索引', removedFile);
        this.$message.warning('文件已从列表中移除，但可能未能从表单数据中删除');
      }
    },
    
    beforeUpload(file) {
      // 首先检查是否已选择客户
      if (!this.orderForm.customerId) {
        this.$message.error('请先选择客户再上传文件');
        return false;
      }
      
      // 检查文件大小
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!');
        return false;
      }
      
      // 可以在这里添加文件类型检查
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif'
      ];
      
      const isAllowedType = allowedTypes.includes(file.type);
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel或图片格式的文件');
        // 返回false明确阻止上传
        return false;
      }
      
      return true;
    },
    
    formatFileSize(size) {
      if (!size) return '0 B';
      
      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      let index = 0;
      let fileSize = parseFloat(size);
      
      while (fileSize >= 1024 && index < units.length - 1) {
        fileSize /= 1024;
        index++;
      }
      
      return fileSize.toFixed(2) + ' ' + units[index];
    },
    
    fetchCustomerList() {
      this.loading.customers = true;
      adminApi.getCustomerList()
        .then(response => {
          this.customerOptions = response.map(item => ({
            value: item.id.toString(),
            label: item.companyName
          }));
          
          // 创建客户数据字典，便于快速查找客户信息
          this.customerData = {};
          response.forEach(item => {
            this.customerData[item.id] = {
              contact: item.contactPerson || '',
              phone: item.contactPhone || '',
              address: item.companyAddress || ''
            };
          });
          
          this.loading.customers = false;
        })
        .catch(error => {
          console.error('获取客户列表失败:', error);
          this.$message.error('获取客户列表失败');
          this.loading.customers = false;
        });
    },
    
    fetchMerchantList() {
      this.loading.merchants = true;
      adminApi.getMerchantList()
        .then(response => {
          console.log('获取到的商家列表:', response);
          this.merchantOptions = response.map(item => ({
            value: item.id.toString(),
            label: item.companyName
          }));
          
          // 创建商家数据字典，便于快速查找商家信息
          this.merchantData = {};
          response.forEach(item => {
            // 获取仪器列表
            const equipmentList = item.deviceInfoList || [];  // 使用deviceInfoList
            
            console.log(`商家[${item.companyName}]的仪器列表:`, equipmentList);
            
            // 处理仪器选项
            const equipment = equipmentList.map(device => ({
              value: device.id.toString(),
              label: device.deviceName || `仪器ID:${device.id}`,
              referencePrice: device.price || '0',
              deviceModel: device.deviceModel || ''
            }));
            
            // 存储商家信息
            this.merchantData[item.id] = {
              contact: item.contactPerson || '',
              phone: item.contactPhone || item.phone || '',
              address: item.companyAddress || item.address || '',
              equipment: equipment
            };
          });
          
          this.loading.merchants = false;
          
          // 如果是编辑模式，确保仪器信息正确加载
          if (this.originalOrderData.id && this.orderForm.merchantId) {
            // 尝试重新加载该商家的仪器信息
            const merchantId = this.orderForm.merchantId;
            if (this.merchantData[merchantId] && this.merchantData[merchantId].equipment.length > 0) {
              console.log(`为商家[${merchantId}]加载了${this.merchantData[merchantId].equipment.length}个仪器`);
              this.equipmentOptions = this.merchantData[merchantId].equipment;
              
              // 如果已经选择了设备，尝试找到对应设备
              if (this.orderForm.deviceId) {
                const selectedDevice = this.equipmentOptions.find(item => item.value === this.orderForm.deviceId);
                if (selectedDevice) {
                  this.orderForm.equipment = selectedDevice.label;
                  this.orderForm.deviceModel = selectedDevice.deviceModel || '';
                  console.log('已找到选中的设备:', selectedDevice);
                }
              }
            }
          }
        })
        .catch(error => {
          console.error('获取商家列表失败:', error);
          this.$message.error('获取商家列表失败');
          this.loading.merchants = false;
        });
    },
    
    getStatusText(statusCode) {
      const statusMap = {
        'NOT_SHIPPED': '未邮寄',
        'SHIPPED': '已邮寄',
        'ACCEPTED': '已接收',
        'TESTING': '测试中',
        'COMPLETED': '已完成'
      };
      
      return statusMap[statusCode] || '未知状态';
    },
    
    getStatusType(status) {
      const statusTypeMap = {
        '未邮寄': 'info',
        '已邮寄': 'warning',
        '已接收': 'warning',
        '测试中': 'primary',
        '已完成': 'success',
        '未知状态': 'danger'
      };
      
      return statusTypeMap[status] || 'info';
    },
    
    updatePriceByTestCount() {
      // 根据样品数量更新价格
      if (this.orderForm.merchantId && this.orderForm.deviceId) {
        const merchantEquipment = this.merchantData[this.orderForm.merchantId]?.equipment || [];
        const selectedEquipment = merchantEquipment.find(item => item.value === this.orderForm.deviceId);
        
        if (selectedEquipment) {
          // 重新计算价格
          const basePrice = parseFloat(selectedEquipment.referencePrice) || 0;
          const totalPrice = basePrice * this.orderForm.sampleCount;
          
          this.orderForm.referencePrice = totalPrice.toFixed(2);
          this.orderForm.actualPrice = totalPrice.toFixed(2);
          
          // 回填仪器型号
          this.orderForm.deviceModel = selectedEquipment.deviceModel || '';
        }
      }
    },
    
    // 添加保存订单编辑的方法
    saveOrderEdit() {
      // 这里添加保存订单的逻辑
      this.$refs['orderForm'].validate((valid) => {
        if (valid) {
          this.$confirm('确认保存订单修改吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 检查是否还有文件正在上传
            if (this.uploadingFiles > 0) {
              this.$message.warning('文件正在上传中，请等待上传完成后再提交');
              return;
            }
            
            // 构建要保存的数据
            const saveData = {
              id: this.originalOrderData.id,
              customerId: this.orderForm.customerId || this.originalOrderData.customerId,
              merchantId: this.orderForm.merchantId || this.originalOrderData.merchantId,
              deviceId: this.orderForm.deviceId || '',
              projectName: this.orderForm.projectName,
              customerPerson: this.orderForm.contact,
              customerPhone: this.orderForm.phone,
              customerAddress: this.orderForm.address,
              testCount: this.orderForm.sampleCount,
              expectedEndTime: this.orderForm.expectedCompletionDate,
              remarks: this.orderForm.remark,
              merchantPerson: this.orderForm.merchantContact,
              merchantPhone: this.orderForm.merchantPhone,
              merchantAddress: this.orderForm.merchantAddress,
              guidePrice: this.orderForm.referencePrice,
              actualPrice: this.orderForm.actualPrice,
              orderFile: this.orderForm.orderFile,
              orderStatus: 'NOT_SHIPPED'
            }
            
            // 调用保存API
            adminApi.editOrder(saveData)
              .then(response => {
                console.log('保存订单响应:', response)
                if (response) {
                  this.$message.success('订单修改成功')
                  // 返回上一页
                  this.$router.back()
                } else {
                  this.$message.error(response.msg || '保存失败')
                }
              })
              .catch(error => {
                console.error('保存订单失败:', error)
                this.$message.error('保存订单失败: ' + (error.message || '未知错误'))
              })
          }).catch(() => {
            this.$message.info('已取消保存')
          })
        } else {
          this.$message.error('表单填写有误，请检查!');
          return false;
        }
      });
    },
    
    // 取消编辑
    cancelEdit() {
      this.$confirm('确认取消编辑？未保存的修改将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 返回详情页
        this.$router.push(`/admin/orders/detail/${this.originalOrderData.id}`)
      }).catch(() => {
        this.$message.info('已取消')
      })
    }
  }
}
</script>

<style scoped>
.order-edit-container {
  padding: 30px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.order-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-form-item__label {
  font-weight: bold;
  color: #606266;
  white-space: nowrap;
  padding-right: 10px;
}

.file-list-container {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
  border-left: 3px solid #409EFF;
}

.no-file {
  padding: 40px 0;
}

.form-actions {
  margin-top: 20px;
  text-align: center;
}

.form-actions .el-button {
  padding: 12px 30px;
  font-size: 16px;
}

.upload-area {
  margin-bottom: 20px;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.form-tip {
  font-size: 12px;
  color: #E6A23C;
  margin-top: 5px;
}
</style> 